/**
 * @generated SignedSource<<e1fa92fc2b6a86cff7daa4b5ed8e3771>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Specialization_Specialization$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "Specialization_Specialization";
};
export type Specialization_Specialization$key = {
  readonly " $data"?: Specialization_Specialization$data;
  readonly " $fragmentSpreads": FragmentRefs<"Specialization_Specialization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Specialization_Specialization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Specialization",
  "abstractKey": null
};

(node as any).hash = "2e24c7d4f0376745f7fb88464e758504";

export default node;
